import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import ThemedSection, { isDark } from './ThemedSection'
import Section from './Section'

const PADDING = 'Padding'
// const NO_PADDING = 'No padding'
const NO_LEFT_PADDING = 'No left padding'
const NO_RIGHT_PADDING = 'No right padding'

export const CombineSections = sections => {
  if (!sections) return null
  if (!sections.length) return null
  const combined = []
  for (let i = 0; i < sections.length; i++) {
    const section = sections[i]
    if (section.strapi_component !== 'section.section-layout') {
      combined.push(section)
      continue
    }
    section.cols = []
    combined.push(section)
    if (sections.length > i + 1) {
      section.cols.push(sections[i + 1])
      sections[i + 1].parent = section
      sections[i + 1].parentPadding = [PADDING, NO_RIGHT_PADDING].includes(section.padding)
      ++i
    }
    if (section.split === 'Single Column') {
      continue
    }
    if (sections.length > i + 1) {
      section.cols.push(sections[i + 1])
      sections[i + 1].parent = section
      sections[i + 1].parentIndex = [PADDING, NO_LEFT_PADDING].includes(section.padding)
      ++i
    }
  }
  return combined
}

export const SectionLayout = ({ section }) => {
  const { split, cols, padding, theme } = section
  let col1, col2, wrapping
  switch (split) {
    case 'Single Column':
      col1 = 'w-11/12 max-w-[1366px] mx-auto'
      break
    case 'Split 60/40':
      wrapping =
        'w-11/12 max-w-[1366px] mx-auto grid xl:grid-cols-[6fr_4fr] justify-center items-center'
      col1 = 'w-full'
      col2 = 'w-full'
      break
    case 'Split 40/60':
      wrapping =
        'w-11/12 max-w-[1366px] mx-auto grid xl:grid-cols-[4fr_6fr] justify-center items-center'
      col1 = 'w-full'
      col2 = 'w-full'
      break
    default:
      wrapping =
        'w-11/12 max-w-[1366px] mx-auto grid xl:grid-cols-[1fr_1fr] justify-center items-center'
      col1 = 'w-full'
      col2 = 'w-full'
  }
  switch (padding) {
    case PADDING:
      col1 += ' py-10 px-5'
      col2 += ' py-10 px-5'
      break
    case NO_LEFT_PADDING:
      col1 += ' py-10 px-5 xl:px-0 xl:py-0'
      col2 += ' py-10 px-5'
      break
    case NO_RIGHT_PADDING:
      col1 += ' py-10 px-5'
      col2 += ' py-10 px-5 xl:px-0 xl:py-0'
      break
    default: // No padding
      col1 += ' py-10 px-5 xl:px-0 xl:py-0'
      col2 += ' py-10 px-5 xl:px-0 xl:py-0'
  }
  if (cols && cols[1] && cols[1].strapi_component === 'section.image-section') {
    col2 = (col2 + ' order-first xl:order-last').trim()
  }
  return (
    <ThemedSection theme={theme}>
      <div className={wrapping + ' relative'}>
        {cols && cols[0] && (
          <Section section={cols[0]} className={col1} isDark={isDark(theme)} theme={theme} />
        )}
        {cols && cols[1] && (
          <Section section={cols[1]} className={col2} isDark={isDark(theme)} theme={theme} />
        )}
      </div>
    </ThemedSection>
  )
}

SectionLayout.propTypes = {
  section: PropTypes.shape({
    strapi_component: PropTypes.string,
    split: PropTypes.string,
    padding: PropTypes.string,
    theme: PropTypes.string,
    cols: PropTypes.arrayOf(PropTypes.object),
  }),
  className: PropTypes.string,
}

export const query = graphql`
  fragment SectionLayout on STRAPI__COMPONENT_SECTION_SECTION_LAYOUT {
    id
    strapi_component
    split
    padding
    theme
  }
`

export default SectionLayout
